(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class FMStickyHeader extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.section-header');
    if (!this.section) return;
    this.mode = this.getAttribute('data-sticky-type');
    this.lastScroll = window.scrollY;
    this.setHeaderHeight = this.setHeaderHeight.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.setHeaderHeight();
    window.addEventListener('resize', this.setHeaderHeight);
    this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
    this.resizeObserver.observe(this.section);
    if (this.mode === 'always' || this.mode === 'reduce-logo-size') this.section.classList.add('shopify-section-header-sticky');
    else if (this.mode === 'on-scroll-up') window.addEventListener('scroll', this.handleScroll, { passive: true });
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.setHeaderHeight);
    window.removeEventListener('scroll', this.handleScroll);
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }
  setHeaderHeight() {
    if (!this.section) return;
    var height = this.section.offsetHeight;
    this.section.style.setProperty('--fm-sticky-height', height + 'px');
    document.documentElement.style.setProperty('--header-height', height + 'px');
  }
  handleScroll() {
    var current = window.scrollY;
    if (current <= this.section.offsetHeight) {
      this.section.classList.remove('fm-header-hidden', 'shopify-section-header-sticky');
      this.lastScroll = current;
      return;
    }
    if (this.querySelector('.fm-mobile-menu[open], .fm-search.is-open, .fm-header__dropdown[open]')) {
      this.section.classList.remove('fm-header-hidden');
      this.lastScroll = current;
      return;
    }
    var movement = current - this.lastScroll;
    if (Math.abs(movement) < 12) return;
    this.section.classList.add('shopify-section-header-sticky');
    this.section.classList.toggle('fm-header-hidden', movement > 0);
    this.lastScroll = current;
  }
}
class FMStaticHeader extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.section-header');
    if (!this.section) return;
    this.setHeaderHeight = this.setHeaderHeight.bind(this);
    this.setHeaderHeight();
    window.addEventListener('resize', this.setHeaderHeight);
    this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
    this.resizeObserver.observe(this.section);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.setHeaderHeight);
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }
  setHeaderHeight() {
    if (!this.section) return;
    document.documentElement.style.setProperty('--header-height', this.section.offsetHeight + 'px');
  }
}
if (!customElements.get('fm-sticky-header')) customElements.define('fm-sticky-header', FMStickyHeader);
if (!customElements.get('fm-static-header')) customElements.define('fm-static-header', FMStaticHeader);

  } catch(e) { console.error(e); }
})();
})();
